import {
  BREAKDOWN_AUDIENCE_MESSAGE_TYPES_ERROR_SUBTITLE,
  BREAKDOWN_AUDIENCE_MESSAGE_TYPES_ERROR_TITLE,
  BREAKDOWN_AUDIENCE_MESSAGE_TYPES_ERROR_SUBTITLE_LINK,
} from 'modules/intelligentInsights/constants';
import { FC } from 'react';
import styled from 'styled-components';
import { TextButton } from 'ui/button';
import { EmptyState } from 'ui/emptyState';
import { ErrorStatePageError } from 'ui/illustrations';
import { colors, spacing } from 'ui/theme';

const Wrapper = styled.div`
  padding: ${spacing.x5} 0;
`;

const DescriptionWrapper = styled.span`
  color: ${colors.textSecondary};
`;

const StyledTextButton = styled(TextButton)`
  padding: 0 ${spacing.quarter};
`;

export const BREAKDOWN_MESSAGE_TYPE_ERROR = 'breakdown-message-type-error';

export type BreakdownMessageTypeErrorProps = {
  onRefresh: () => void;
};
export const BreakdownMessageTypeError: FC<BreakdownMessageTypeErrorProps> = ({ onRefresh }) => {
  return (
    <Wrapper data-error="true" data-test={BREAKDOWN_MESSAGE_TYPE_ERROR}>
      <EmptyState
        Illustration={ErrorStatePageError}
        title={BREAKDOWN_AUDIENCE_MESSAGE_TYPES_ERROR_TITLE}
        subtitle={
          <DescriptionWrapper>
            {BREAKDOWN_AUDIENCE_MESSAGE_TYPES_ERROR_SUBTITLE}
            <StyledTextButton
              onClick={() => {
                onRefresh?.();
              }}
            >
              {BREAKDOWN_AUDIENCE_MESSAGE_TYPES_ERROR_SUBTITLE_LINK}
            </StyledTextButton>
          </DescriptionWrapper>
        }
      />
    </Wrapper>
  );
};
